import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogAlertComponent } from '../dialogs/dialog-alert/dialog-alert.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'polylearn-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss']
})
export class TimerComponent implements OnInit {
  @Input() counter: number;
  @Input() started: number;
  @Input() triggerWarning: boolean;
  @Input() supportId: string | number;

  @Output() onTimerUpdate = new EventEmitter<number>();

  internalCounter: number;
  _isCounterStarted: boolean = false;

  constructor(public dialog: MatDialog, private translate: TranslateService) {}

  ngOnInit() {
    this.internalCounter = this.counter;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['started']?.currentValue === true) {
      this._stopTimer();
      this._startTimer();
    }

    if (changes['started']?.currentValue === false) {
      this._stopTimer();
    }

    if (changes['supportId']) {
      this.internalCounter = this.counter;
      if (this.started) {
        this._stopTimer();
        this._startTimer();
      }
    }
  }

  private _timeout;
  private _startTimer() {
    this._isCounterStarted = true;
    if (this.internalCounter !== 0) {
      this._timeout = setInterval(() => {
        if (this.internalCounter === 0) {
          this._stopTimer();
          if (this.triggerWarning) {
            this.triggerWarn();
          }
          return;
        }
        this.internalCounter--;

        this.onTimerUpdate.emit(this.internalCounter);
      }, 1000);
    }
  }

  private _stopTimer() {
    this._isCounterStarted = false;
    if (this._timeout) {
      clearInterval(this._timeout);
    }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this._timeout) {
      this._stopTimer();
    }
  }

  triggerWarn() {
    this.translate.get(['timer.title', 'timer.content']).subscribe(res => {
      const dialogRef = this.dialog.open(DialogAlertComponent, {
        data: {
          title: res['timer.title'],
          textContent: res['timer.content']
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log(`Dialog result: ${result}`);
      });
    });
  }
}
